<template>
  <ui-box class="ui-box-apply" bgType="dark">
    <template v-slot:nav-left>
      <ui-tag class="title">
        <i></i>
        <div class="label-box">
          <span class="label-shadow">战队报名</span>
          <span class="label-text">战队报名</span>
        </div>
      </ui-tag>
    </template>
    <template v-slot:nav-right>
      <div class="right-box">
        <ui-frame-bg class="modal-btn prize" colorType="green" hook @click.native="handleShowPrize">
          <i></i>
          <div class="label-box">
            <span class="label-shadow">奖金规则</span>
            <span class="label-text">奖金规则</span>
          </div>
        </ui-frame-bg>
        
        <ui-frame-bg class="modal-btn notice" colorType="green" hook @click.native="handleShowNotic">
          <i></i>
          <div class="label-box">
            <span class="label-shadow">报名须知</span>
            <span class="label-text">报名须知</span>
          </div>
        </ui-frame-bg>
        <ui-frame-bg class="modal-btn rule" colorType="green" hook @click.native="handleShowRule">
          <i></i>
          <div class="label-box">
            <span class="label-shadow">完整赛制</span>
            <span class="label-text">完整赛制</span>
          </div>
        </ui-frame-bg>
      </div>
    </template>
    <template v-slot:container>
      <div
        class="inner-container"
        :style="{
          'background-image': `url(${$lg(config, 'registration_kv', '')})`
        }"
      >
        <div class="logos"></div>
        <div class="bottom-box">
          <ui-frame-bg class="btn" colorType="yellow" @click.native="startApply">
            <div v-if="$lg(Info, 'team_status', 0) == 0" class="label-box">
              <span class="label-shadow">开始报名</span>
              <span class="label-text">开始报名</span>
            </div>
            <div v-else class="label-box">
              <span class="label-shadow">查看报名状态</span>
              <span class="label-text">查看报名状态</span>
            </div>
          </ui-frame-bg>
          <!-- TODO 报名结束后展示 -->
          <!-- <button class="btn">
             <span>报名结束</span>
          </button> -->
        </div>
      </div>
    </template>

    <modal-rule ref="rule" />
    <modal-notic :agree="Info.agree" ref="notic" />
    <modal-prize :agree="Info.agree" ref="prize" />
  </ui-box>
</template>

<script>
import { mapState } from 'vuex'
import UiBox from '@/components/ui-box'
import UiTag from '@/components/ui-tag';
import UiFrameBg from '@/components/ui-frame-bg';
import ModalRule from './modal/rule'
import ModalNotic from './modal/notic'
import ModalPrize from '@/views/prize/modal/prize'

export default {
  components: { UiBox, UiTag, UiFrameBg, ModalRule, ModalNotic, ModalPrize },
  inject: ['handleStep', 'json_config', 'apply_info', 'promptMsg'],
  computed: {
    ...mapState(['token']),
    config() {
      return this.json_config()
    },
    Info() {
      return this.apply_info()
    }
  },
  methods: {
    handleShowRule() {
      this.$refs.rule.showModal()
    },
    handleShowNotic() {
      this.$refs.notic.showModal()
    },
    handleShowPrize() {
      this.$refs.prize.showModal()
    },
    startApply() {
      if (!this.token) {
        this.promptMsg('未检测到token')
        return
      }

      let subTime = new Date().getTime()
      let registration_start_time =
        this.$lg(this.config, 'registration_start_time', 0) * 1000
      let registration_end_time =
        this.$lg(this.config, 'registration_end_time', 0) * 1000
      // 如果已报名, 直接检查报名进度
      if (this.$lg(this.Info, 'team_status', 0) > 0) {
        this.handleStep(5)
      } else {
        // 未报名状态下, 检查是否在报名期间
        if (subTime < registration_start_time) {
          this.promptMsg('报名未开启')
        } else if (
          subTime >= registration_start_time &&
          subTime <= registration_end_time
        ) {
          // --- 报名开启 ---
          // 未同意报名须知，打开报名须知
          if (!this.Info.agree) {
            this.handleShowNotic()
          } else {
            this.handleStep(2)
          }
        } else {
          this.promptMsg('报名已结束')
        }
      }

      // 埋点
      if (typeof tapdb == 'undefined') return
      tapdb.trackEvent('点击报名')
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 500;
  i {
    position: relative;
    @include sizeSet($width: 36px, $height: 36px);
    @include icon_status('apply_1', $hook: 'all');
    margin-right: get_vh(8px);
  }
}

.right-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .modal-btn {
    @include sizeSet($width: 130px, $height: 40px);
    @include fontSet(20px);
    @include marginSet($marginLeft: 10px);
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    @include boxShadowSet_Btn;
    i {
      display: inline-block;
      @include sizeSet($width: 25px, $height: 25px);
      @include marginSet($marginRight: 5px);
    }
  }
  .modal-btn.rule {
    i {
      @include icon_status('btn_match', $hook: 'all');
    }
  }
  .modal-btn.notice {
    i {
      @include icon_status('btn_apply', $hook: 'all');
    }
  }
  .modal-btn.prize {
    i {
      @include icon_status('btn_reward', $hook: 'all');
    }
  }
}

.inner-container {
  position: relative;
  // width: get_vw(1404px);
  width: 97%;
  height: get_vh(594px);
  margin: get_vh(25px) auto 0;
  border-radius: get_vh(14px);
  border: get_vh(4px) solid #fff;
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  @include boxShadowSet_Container;
  .logos{
    position: absolute;
    top: get_vh(8px);
    left: get_vh(18px);
    background-image: url('https://website.xdcdn.net/poster/58881/20250717/K6fc83RN.png');
    background-size: contain;
    background-position: left center;
    background-repeat: no-repeat;
    width: get_vw(210px);
    height: get_vw(63px);
  }
  .bottom-box {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: get_vh(112px);
    display: flex;
    justify-content: center;
    align-items: center;
    .btn {
      width: get_vh(266px);
      height: get_vh(70px);
      font-size: get_vh(28px);
      font-weight: bold;
      @include boxShadowSet_Btn;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      &:active {
        opacity: 0.9;
      }
    }
  }
}


@media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (orientation: landscape) {
   .inner-container{
      // width: 97% !important;
      background: url('https://website.xdcdn.net/poster/58881/2024_EventsCentre/FVa1Qelu.jpg') no-repeat !important;
      background-size: cover !important;
      background-position: top !important;
   }
  }

</style>